import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import PrimerFactor from './components/PrimerFactor';
import TercerFactor from './components/TercerFactor';

class SecurityFactors extends Component {
  constructor(props) {
    super(props);
    this.state = {
      callbackSuccess: props.onSuccess
    };
  }

  handleHide = () => {
    const { closeChallenge } = this.props;

    closeChallenge();
  };

  handleExit = () => {
    const { challenges, isChallengeValid } = this.props;
    const { callbackSuccess } = this.state;

    if (isChallengeValid && challenges.length === 0) {
      callbackSuccess();
      this.handleHide();
    }
  };

  render() {
    const { challenges, operation } = this.props;

    return (
      <Modal
        show={challenges.length > 0}
        onHide={this.handleHide}
        onExit={this.handleExit}
      >
        <Modal.Header closeButton>Seguridad</Modal.Header>
        <Modal.Body>
          {challenges.map(challenge => {
            if (challenge === '1') {
              return <PrimerFactor key={challenge} operation={operation}/>;
            }
            if (challenge === '3') {
              return <TercerFactor key={challenge} operation={operation}/>;
            }
            return null;
          })}
        </Modal.Body>
      </Modal>
    );
  }
}

export default SecurityFactors;
